import {
  format,
  addMinutes,
  setHours,
  setMinutes,
  subMinutes,
  differenceInMinutes,
  startOfDay,
  endOfDay,
} from 'date-fns';
import { INTERVAL_IN_MINUTES } from 'components/Form';

const MINUTES_PER_HOUR = 60;

// Function returns array of times generated +/-60 mins for passed value
export const getCustomDayTimes = (currentTime, intl) => {
  if (!currentTime) return;

  const hours = currentTime.split(':')[0];
  const minutes = currentTime.split(':')[1];
  const startRunningDate = setHours(setMinutes(new Date(), minutes), hours);
  const times = [];

  // Generate times for period between midnight and current time e.g., 12:00 AM - 12:30 AM
  const minutesAfterMidnight = differenceInMinutes(startRunningDate, startOfDay(new Date()));
  const intervalsPerHourAfterMidnight =
    minutesAfterMidnight < MINUTES_PER_HOUR && minutesAfterMidnight >= 0
      ? minutesAfterMidnight / INTERVAL_IN_MINUTES
      : MINUTES_PER_HOUR / INTERVAL_IN_MINUTES;

  let positiveRunningDate =
    minutesAfterMidnight < MINUTES_PER_HOUR && minutesAfterMidnight >= 0
      ? subMinutes(startRunningDate, minutesAfterMidnight)
      : subMinutes(startRunningDate, MINUTES_PER_HOUR);

  for (let i = 0; i < intervalsPerHourAfterMidnight; i += 1) {
    times.push({
      label: intl.formatDate(positiveRunningDate, { format: 'time' }),
      value: format(positiveRunningDate, 'HH:mm'),
    });
    positiveRunningDate = addMinutes(positiveRunningDate, INTERVAL_IN_MINUTES);
  }

  // Generate times for period between current time and midnight e.g., 11:30 PM - 11:59 PM
  const minutesBeforeMidnight = Math.abs(differenceInMinutes(endOfDay(new Date()), startRunningDate));
  const intervalsPerHourBeforeMidnight =
    minutesBeforeMidnight < MINUTES_PER_HOUR
      ? minutesBeforeMidnight / INTERVAL_IN_MINUTES
      : MINUTES_PER_HOUR / INTERVAL_IN_MINUTES + 1;

  let negativeRunningDate = startRunningDate;

  for (let i = 0; i < intervalsPerHourBeforeMidnight; i += 1) {
    times.push({
      label: intl.formatDate(negativeRunningDate, { format: 'time' }),
      value: format(negativeRunningDate, 'HH:mm'),
    });
    negativeRunningDate = addMinutes(negativeRunningDate, INTERVAL_IN_MINUTES);
  }

  return times;
};
